<!--
 * @Author: your name
 * @Date: 2020-10-20 13:25:05
 * @LastEditTime: 2021-06-10 12:08:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ccs-www-ng\src\components\question_answer.vue
-->
<template>
  <p class="question-answer">
    {{ answer }}
  </p>
</template>

<style lang="less" scoped>
.question-answer {
  margin: 0;
  padding: 10px;
}
</style>

<script>
const debug = require('debug')('ccs:component:question-answer');
import { findIndex } from 'lodash';

export default {
	props: {
		question: Object
	},
	computed: {
		answer: function() {
			const question = this.question;
			debug('[answer] question: %o', question);
			if (
				[
					'1101',
					'1102',
					'1103',
					'1104',
					'1105',
					'1106',
					'1107',
					'1108',
					'1201',
					'1202',
					'1203',
					'1204',
					'1205',
					'1206',
					'1401',
					'1402',
					'1403',
					'1404',
					'1405',
					'1406',
					'5101',
					'8601',
					'8602',
					'8604',
					'1502',
					'1208'
				].includes(question.type) &&
        question.section &&
        question.answer
			) {
				//选择题
				let sectionList = question.section;
				let i = findIndex(sectionList, function(item) {
					return item === question.answer;
				});

				if (i > -1) {
					return String.fromCharCode(i + 65);
				}
				return question.answer;
			} else if (question.section) {
				if (
					question.type === '1207' ||
          question.type === '1301' ||
          question.type === '1501'
				) {
					let sectionList = question.section;
					let i = findIndex(sectionList, function(o) {
						return o.isRight;
					});
					if (i > -1) {
						return String.fromCharCode(i + 65);
					}
				}
			}

			return '';
		}
	}
};
</script>
